import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useToast } from '@chakra-ui/react';

import { useTestCount } from '@/hooks/useTestCount';

const ALLOWED_PATHS = [
  '/test',
  '/home',
  '/top',
  '/profile',
  '/test/mini-test',
  '/test/proficiency-test',
  '/test/check-test',
];

const TestAvailabilityGuard = () => {
  const { totalTestCount, hasProficiencyTest } = useTestCount();
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();
  const { t } = useTranslation();

  useEffect(() => {
    if (
      hasProficiencyTest &&
      !ALLOWED_PATHS.some((path) => location.pathname.startsWith(path))
    ) {
      toast({
        title: t(
          'test-available-tooltip',
          'Please complete available tests first',
        ),
        status: 'warning',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
      navigate('/home', { replace: true });
    }
  }, [
    totalTestCount,
    location.pathname,
    navigate,
    toast,
    t,
    hasProficiencyTest,
  ]);

  return <Outlet />;
};

export default TestAvailabilityGuard;
